import React from 'react'
import { Stack, Typography } from '@mui/material'
import CustomModalClose from 'src/components/CustomComponents/CustomModalClose'
import CustomButton from 'src/components/CustomComponents/CustomButton'

interface ModalOptionItem {
	label: string
	onClick: () => void
	color?: string
	bgColor?: string
	borderColor?: string
}

interface ModalOptionProps {
	open: boolean
	handleClose: () => void
	label: string
	options: ModalOptionItem[]
}

function ModalOption({ open, handleClose, label, options }: ModalOptionProps) {
	return (
		<CustomModalClose
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Stack alignItems="center" spacing={2} sx={{ margin: '10px 0' }}>
				<Typography sx={{ textAlign: 'center', width: '100%'}}>{label}</Typography>
				<Stack direction="row" className='w-100 justify-content-center'  spacing={1}>
					{options.map((option, index) => {
						const textColor = option.color || '#124984'
						const backgroundColor = option.bgColor || '#ffffff'
						const borderColor = option.borderColor || textColor

						return (
							<CustomButton
								key={index}
								variant="outlined"
								className='w-100'
								sx={{
									width: '100%',
									background: backgroundColor,
									color: textColor,
									border: `1px solid ${borderColor}`,
									':hover': {
										background: backgroundColor,
										color: textColor,
										border: `1px solid ${borderColor}`,
									},
								}}
								onClick={() => {
									option.onClick()
									handleClose()
								}}
							>
								{option.label}
							</CustomButton>
						)
					})}
				</Stack>

				<Stack direction="row" spacing={3}>
                    <CustomButton
                        variant="outlined"
                        className='w-100'
                        sx={{
							width: '100%',
                            background: 'red',
                            color: 'white',
                            border: '1px solid red',
                            ':hover': {
                                color: 'red',
                                border: '1px solid red',
                            },
                        }}
                        onClick={handleClose}
                    >
                        Cancel
                    </CustomButton>
				</Stack>
			</Stack>
		</CustomModalClose>
	)
}

export default React.memo(ModalOption)
